import { Breadcrumb, Card, Col, Form, Row, Typography } from 'antd';
import { useEffect } from 'react';
import { ReadmeIcon } from '../components/assets/ReadmeIcon';
import { useStoreActions, useStoreState } from '../store';
import TntManagementContainer from '../components/timeInTransit/TntManagementContainer';
const { Text } = Typography;

const TntManagementPage = () => {
  const setPageTitle = useStoreActions((actions) => actions.navigation.setPageTitle);
  const sessionPartnerSlug = useStoreState((state) => state?.session?.user?.sessionPartnerUrl);
  const pageLoading = useStoreState((state) => state.loading.loadingFlags.page);
  const timeInTransitSimulationTableData = useStoreState(
    (state) => state.timeInTransit.timeInTransitSimulationTableData,
  );
  const prodDataSetType = useStoreState((state) => state.timeInTransit.prodDataSetType);
  const [form] = Form.useForm();

  useEffect(() => {
    setPageTitle(`Time in Transit Management`);
  }, [setPageTitle, pageLoading]);

  useEffect(() => {
    if (timeInTransitSimulationTableData.length) {
      form.validateFields(['download']);
    }
  }, [prodDataSetType, form, timeInTransitSimulationTableData]);

  return (
    <Card bodyStyle={{ paddingTop: 0 }}>
      <div style={{ marginTop: 8, paddingBottom: '10px' }}>
        <Row>
          <Col span={20}>
            <Breadcrumb separator=">">
              <Breadcrumb.Item>
                <a href={`/${sessionPartnerSlug}`}>
                  <Text>Home</Text>
                </a>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Text>
                  <b>Time in Transit Management</b>
                </Text>
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col span={4} style={{ textAlign: 'right' }}>
            <a rel="noreferrer" target="_blank" href={`https://docs.shipium.com/docs/time-in-transit-estimations`}>
              <ReadmeIcon style={{ fontSize: '20px' }} />
            </a>
          </Col>
        </Row>
      </div>
      <TntManagementContainer showTabs={true} />
    </Card>
  );
};

export default TntManagementPage;
